/**
 * Capitalização de nomes de pessoa — o mesmo Title Case brasileiro do backend
 * (`bhunter_core.normalizacao.capitalizar_nome`): conectivos ('de', 'da', 'dos', 'e'…) minúsculos
 * exceto no início; cada parte de um nome composto com hífen é capitalizada. Só ajusta a caixa —
 * não mexe em acento nem remove nada. Idempotente. "VINICIUS DA SILVA" → "Vinicius da Silva".
 *
 * Usado como `mutator` de campo (aplicado ao sair do campo) para dar consistência imediata no
 * cadastro; o backend reaplica o mesmo no create/update/extração, então a base nunca guarda um nome
 * em caixa torta, venha ele de onde vier.
 */
const CONECTIVOS = new Set([
  'de', 'da', 'do', 'das', 'dos', 'e', 'di', 'du', 'del', 'della', 'van', 'von', 'y',
]);

export function capitalizarNome(valor: string): string {
  return valor
    .trim()
    .replace(/\s+/g, ' ')
    .split(' ')
    .filter((p) => p !== '')
    .map((p, i) => {
      const baixo = p.toLowerCase();
      if (i > 0 && CONECTIVOS.has(baixo)) return baixo;
      return baixo
        .split('-')
        .map((t) => t.charAt(0).toUpperCase() + t.slice(1))
        .join('-');
    })
    .join(' ');
}
